'use strict';

var basePage = require('./base-page.js');
var reactControls = require('./react/react-controls.js');
var infinite = require('./ui/infinite.js');
var panels = require('./components/panels.js');

basePage.init = function() {
    basePage.initBasePage();

    reactControls.render();
    infinite.init();
    panels.init();
};

module.exports = basePage;